export const routePaths = {
  dashboard: '/',
  survey: {
    questionnaire: '/survey/:questionnaireName',
    questionnaireRevision:
      '/survey/:questionnaireName/revision/:questionnaireRev',
    lossNotice: '/survey/notice/:lossNoticeId',
  },
  lossNotice: {
    history: '/notice/history/:refId',
  },
  admin: {
    datasets: {
      index: '/admin/datasets',
      detail: '/admin/datasets/:name',
    },
    questionnaires: {
      index: '/admin/questionnaires',
      detail: '/admin/questionnaires/:id',
    },
    clientId: {
      index: '/admin/clientIds',
      detail: '/admin/clientIds/:clientName',
    },
    varassetExports: '/admin/varasset-exports',
  },
  reporting: {
    mediaAttachment: '/reporting/media-attachment',
  },
  notAuthorized: '/not-authorized',
};

export const permissions = {
  questionnaireAdmin: 'admin:questionnaires',
  datasetAdmin: 'admin:datasets',
  submitWithoutApproval: 'notice:SubmitWithoutApproval',
  canApproveNotice: 'notice:approve',
  cautionSectionsVisible: 'not_implemented',
};

export const claimTypes = {
  permissions: 'http://cmrclaims.com/claims/permissions',
};
